import React from 'react'
import MaterialSymbol from '../material-symbol'

const Receipt = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="receipt" {...props} />
))

Receipt.displayName = 'Receipt'

export default Receipt
